<template>
    <div class="map-tab" @click="replace && $emit('update:replace', false)">
        <div class="tab-header">
            <span
                v-for="(tab, index) in tabs"
                :key="tab.label"
                class="item"
                :class="{ active: activeIndex === index }"
                @click="activeIndex = index"
            >
                {{ tab.label + ' (' + tab.data?.length +')' }}
            </span>
        </div>
        <div class="tab-body" ref="schoolListContainer">
            <div
                v-for="(group, i) in tabs"
                v-show="activeIndex === i"
                :key="i"
            >
                <div class="tab-content school-list">
                    <div class="school-item school-header">
                        <div class="score"></div>
                        <div class="name-address">
                            {{ $t('school.name') }}
                        </div>
                        <div class="category">
                            {{ $t('school.category') }}
                        </div>
                        <div class="grades">
                            {{ $t('school.grades') }}
                        </div>
                        <div class="library">
                            {{ $t('school.library') }}
                        </div>
                        <div class="ratio">{{ $t('school.ratio') }}</div>
                    </div>
                    <div
                        v-for="(school, index) in group.data"
                        :key="index"
                        class="school-item server-property"
                        :class="{
                            active:
                                itemActiveKey ===
                                school.latitude + '-' + school.longitude
                        }"
                        v-show="index < 5 || (index >= 5 && opened)"
                    >
                        <div
                            class="school-content"
                        >
                            <div
                                class="score"
                                :class="[
                                    'score-' + school.gsRating,
                                    {
                                        high: school.gsRating > 9,
                                        middle:
                                            school.gsRating >= 6 &&
                                            school.gsRating <= 9,
                                        low:
                                            !school.gsRating ||
                                            school.gsRating < 6
                                    }
                                ]"
                            >
                                {{ school.gsRating || 0 }}<span class="full-marks">/10</span>
                            </div>
                            <div class="name-address">
                                <div class="school-name">{{ school.name }}</div>
                                <div class="school-address">
                                    {{ calcAddress(school) }}
                                </div>
                            </div>
                            <div class="category">
                                <div v-if="isMobile" class="label">{{ $t('school.category') }}</div>
                                <div class="info">{{ school.admission }}</div>
                            </div>
                            <div class="grades">
                                <div v-if="isMobile" class="label">{{ $t('school.grades') }}</div>
                                <div class="info">{{ school.gradeLow }} - {{ school.gradeHigh }}</div>
                            </div>
                            <div class="library">
                                <div v-if="isMobile" class="label">{{ $t('school.library') }}</div>
                                <div class="info">{{ school.library ? $t('common:yes') : $t('common:no') }}</div>
                            </div>
                            <div class="ratio">
                                <div v-if="isMobile" class="label">{{ $t('school.ratio') }}</div>
                                <div class="info">{{ school.studentTeacherRatio }} {{ $t('school.students') }}/{{ $t('school.teachers') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="school-more"
            :class="{ opened: opened }"
            v-if="tabs[activeIndex]?.data?.length > 5"
            @click="toggle"
        >
            {{
                opened
                    ? $t('common:viewMore.showLess') || 'Show Less'
                    : $t('common:viewMore.showMore') || 'Show More'
            }}
        </div>
    </div>
</template>

<script>
import { calcAddress } from '@/components/map/js/markers';

export default {
    i18next: {
        ns: 'md-map'
    },
    emits: [
        'updateMarkerData',
        'updateMarkerEvent',
        'updateMapClickEvent',
        'doMapEvent',
        'update:replace'
    ],
    props: {
        replace: {
            type: Boolean,
            default: false
        },
        tabs: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeIndex: 0,
            itemActiveKey: '',
            opened: false,
        };
    },
    computed: {
        isMobile() {
            return this.platform.isMobile;
        }
    },
    created() {
        this.activeIndex = 0;
    },
    methods: {
        calcAddress,
        toggle() {
            this.opened = !this.opened;

            if (!this.opened) {
                this.$nextTick(() => {
                    const container = this.$refs.schoolListContainer;
                    if (container) {
                        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';

.md-map.layout2 {
    .map-tab {
        width: 100%;
        .tab-header {
            display: flex;
            gap: 30px;
            .item {
                padding-bottom: 15px;
                font-family: var(--font-normal);
                font-size: 18px;
                line-height: 1.5;
                color: var(--g-primary-color);
                opacity: 0.5;
                text-transform: capitalize;
                white-space: nowrap;
                cursor: pointer;
                &.active {
                    opacity: 1;
                    border-bottom: 3px solid var(--g-primary-color);
                }
            }
        }
        .tab-body {
            width: 100%;
            .tab-content {
                width: 100%;
                .school-item {
                    width: 100%;
                    height: 80px;
                    position: relative;
                    &:nth-child(even)::after {
                        content: '';
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 1;
                        background: var(--g-primary-color);
                        opacity: 0.05;
                    }
                }
                .school-header {
                    height: auto;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    padding: 20px 50px 20px 20px;
                    div {
                        font-family: var(--font-normal);
                        font-size: 12px;
                        line-height: 1.5;
                        color: var(--g-tip-color);
                    }
                }
                .school-content {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    position: relative;
                    cursor: default;
                    padding: 0 50px 0 20px;
                    
                    > div {
                        font-family: var(--font-normal);
                        font-size: 14px;
                        line-height: 1.5;
                        color: var(--g-text-color);
                    }
                    .score {
                        width: 50px;
                        height: 50px;
                        line-height: 50px;
                        border-radius: 50%;
                        margin: 0 auto;
                        font-family: var(--font-medium);
                        font-size: 24px;
                        text-align: center;
                        color: var(--g-bg-color);
                        background-color: var(--g-text-color);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        // &.high {
                        //     background-color: #33cf81;
                        // }
                        // &.middle {
                        //     background-color: #77b0fd;
                        // }
                        // &.low {
                        //     background-color: #bbcbd7;
                        // }
                        .full-marks {
                            font-family: var(--font-normal);
                            font-size: 12px;
                            padding-top: 4px;
                        }
                    }
                    .school-name {
                        white-space: normal;
                        font-family: var(--font-medium);
                        font-size: 16px;
                        line-height: 1.5;
                        color: var(--g-primary-color);
                        @include webkitBox(1);
                    }
                    .school-address {
                        margin-top: 5px;
                        @include webkitBox(1);
                        text-decoration: none;
                    }
                    .category {
                        .info {
                            display: inline-block;
                            font-family: var(--font-medium);
                            padding: 2px 8px;
                            border-radius: 100px;
                            overflow: hidden;
                            font-family: var(--font-medium);
                            font-size: 14px;
                            line-height: 1.5;
                            color: var(--g-primary-color);
                            position: relative;
                            &::after {
                                content: '';
                                position: absolute;
                                width: 100%;
                                height: 100%;
                                left: 0;
                                top: 0;
                                background: var(--g-primary-color);
                                opacity: 0.05;
                            }
                        }
                    }
                }
                .score {
                    width: 50px;
                }
                .name-address {
                    flex: 2.3;
                }
                .category,
                .grades,
                .library,
                .ratio {
                    flex: 1;
                }
            }
        }
        .school-more {
            margin-top: 20px;
            font-family: var(--font-normal);
            font-size: 14px;
            line-height: 24px;
            color: var(--g-tip-color);
            text-decoration: underline;
            text-align: center;
            cursor: pointer;
            &:hover {
                color: var(--g-btn-background);
            }
        }

        @include media-800 {
            .tab-header {
                gap: 20px;
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: none;
                &::-webkit-scrollbar {
                    width: 0;
                    height: 0;
                }
                .item {
                    font-size: 14px;
                }
            }
            .tab-body {
                .tab-content {
                    .school-header {
                        display: none;
                    }
                    .school-item {
                        height: 206px;
                        &:nth-child(even)::after {
                            content: none;
                        }
                    }
                    .school-content {
                        flex-wrap: wrap;
                        column-gap: 10px;
                        row-gap: 18px;
                        padding: 20px 0;
                        border-bottom: 1px solid rgba(218, 218, 218, 0.5);
                        .score {
                            margin-right: 5px;
                        }
                        .label {
                            font-family: var(--font-normal);
                            font-size: 12px;
                            line-height: 14px;
                            color: var(--g-tip-color);
                            margin-bottom: 4px;
                        }
                    }
                    .name-address {
                        flex: none;
                        width: calc(100% - 50px - 15px);
                    }
                    .category,
                    .grades,
                    .library {
                        flex: none;
                        width: calc((100% - 10px * 2) / 3);
                    }
                    .ratio {
                        flex: none;
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
